import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { Trophy, Crown, Medal } from "lucide-react";
import { useAuth } from "../lib/auth";

const podiumStyles = [
  { icon: Crown, color: "text-gold-hover", bg: "bg-gold", size: 56 },
  { icon: Medal, color: "text-ink-700", bg: "bg-parchment-dark", size: 48 },
  { icon: Medal, color: "text-compass", bg: "bg-orange-100", size: 44 },
];

function LBList({ data, scoreKey = "total_points", nameKey = "name", testIdPrefix = "leaderboard" }) {
  if (!data?.length) return <Card className="card-treasure p-8 text-center text-ink-500">Nessun dato</Card>;
  const top3 = data.slice(0, 3);
  const rest = data.slice(3);
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-3 gap-3" data-testid={`${testIdPrefix}-podium`}>
        {top3.map((u, i) => {
          const S = podiumStyles[i];
          return (
            <Card key={u.user_id || i} className={`card-treasure p-4 text-center ${i===0 ? "order-2 -mt-4" : i===1 ? "order-1" : "order-3"}`}>
              <div className={`w-16 h-16 mx-auto rounded-3xl ${S.bg} flex items-center justify-center shadow-tactile mb-2`}>
                <S.icon className={S.color} size={28} />
              </div>
              <div className="text-2xl font-display font-extrabold text-ink-900">{u[scoreKey]}</div>
              <div className="text-xs text-ink-500 font-bold uppercase tracking-widest">{u[nameKey] || u.user_name}</div>
            </Card>
          );
        })}
      </div>
      <Card className="card-treasure divide-y divide-outline">
        {rest.map((u, i) => (
          <div key={u.user_id || i} className="flex items-center gap-4 p-4">
            <div className="w-9 h-9 rounded-xl bg-parchment-dark flex items-center justify-center font-display font-bold text-ink-800">{i+4}</div>
            <div className="flex-1 font-bold text-ink-800">{u[nameKey] || u.user_name}</div>
            <div className="font-display font-extrabold text-gold-hover">{u[scoreKey]} pt</div>
          </div>
        ))}
      </Card>
    </div>
  );
}

export default function Leaderboard() {
  const { user } = useAuth();
  const [tab, setTab] = useState("global");
  const [global, setGlobal] = useState(null);
  const [family, setFamily] = useState(null);

  useEffect(() => {
    api.get("/leaderboard/global").then((r) => setGlobal(r.data));
    if (user?.family_id) api.get("/leaderboard/family").then((r) => setFamily(r.data));
  }, [user?.family_id]);

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-2xl bg-gold flex items-center justify-center shadow-tactile">
          <Trophy className="text-ink-900" size={26}/>
        </div>
        <div>
          <h1 className="font-display font-extrabold text-3xl text-ink-900">Classifica</h1>
          <p className="text-ink-500 text-sm">Chi è il miglior esploratore?</p>
        </div>
      </div>

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="bg-parchment-dark rounded-2xl p-1">
          <TabsTrigger value="global" className="rounded-xl data-[state=active]:bg-white data-[state=active]:shadow-md" data-testid="tab-global">Globale</TabsTrigger>
          <TabsTrigger value="family" disabled={!user?.family_id} className="rounded-xl data-[state=active]:bg-white data-[state=active]:shadow-md" data-testid="tab-family">Famiglia</TabsTrigger>
        </TabsList>
        <TabsContent value="global" className="mt-6">
          {global && <LBList data={global} testIdPrefix="global" />}
        </TabsContent>
        <TabsContent value="family" className="mt-6">
          {family && <LBList data={family} testIdPrefix="family" />}
        </TabsContent>
      </Tabs>
    </div>
  );
}
